import { MutationObserverOptions, useMutation } from '@tanstack/react-query';

import SESSION_TOKEN_SERVICE from '@/constants/SessionTokenService';

import { TError } from '@/api';

export const useMutationWithPartnerRefetch = <
	TData = unknown,
	TMutationError = TError,
	TVariables = void,
	TContext = unknown,
>(
	options: MutationObserverOptions<TData, TMutationError, TVariables, TContext>,
): ReturnType<typeof useMutation<TData, TMutationError, TVariables, TContext>> => {
	return useMutation<TData, TMutationError, TVariables, TContext>({
		...options,
		onError: (error, variables, context) => {
			if (typeof error === 'object' && error !== null && Reflect.get(error, 'status') === 401) {
				SESSION_TOKEN_SERVICE.removeToken();
			}

			options.onError?.(error, variables, context);
		},
	});
};
